import { Navigate } from "react-router";

import { HASURA_EDITOR_ROLES, useAuthorization } from "./authorization";

export function DeweyHomeRedirect() {
  const { checkAccess } = useAuthorization();
  return (
    <Navigate
      to={checkAccess({ allowedRoles: HASURA_EDITOR_ROLES }) ? "/entities" : "/compound-record-versions"}
      replace
    />
  );
}
